module.exports = __webpack_public_path__ + "images/emoji/kissing_heart.2cdfe6f3e63d2f613f75.png";